import React, { useCallback } from "react"

import { SelectOption } from "../../../models/common"
import useDictionary from "../../../hooks/useDictionary"

interface Props {
  formFunctions: any
  name?: string
  label: string
  options: SelectOption[]
  required?: boolean
  hideLabel?: boolean
  instructions?: string
  pageContext: any
}

const defaultProps = {}

const CheckboxGroup: React.FC<Props> = props => {
  // react-hook-form
  const register = props.formFunctions.register
  const errors = props.formFunctions.errors

  // field props
  const input_name = props.name || props.label
  const input_id = input_name.split(" ").join("_")

  // validation
  const validate = useCallback(() => {
    if (!props.required) return true
    const value = props.formFunctions.getValues()[input_name]
    const isValid = value.length && value.length > 0
    return (
      isValid ||
      `${props.label} ${useDictionary("is required", props.pageContext.locale)}`
    )
  }, [props.label, input_name, props.required])

  return (
    <div className="form__field">
      <label htmlFor={input_id}>
        {props.hideLabel ? (
          <span className="show-for-sr">{props.label}</span>
        ) : (
          <>
            {props.label}
            {props.required ? " *" : ""}
          </>
        )}
      </label>

      {props.options.map(option => (
        <div key={option.value} className="field__input checkbox">
          <input
            id={input_id}
            type="checkbox"
            value={option.value}
            {...register(input_name, { validate })}
          />
          <label htmlFor={input_id}>{option.label}</label>
        </div>
      ))}

      {props.instructions && (
        <div className="field__help">{props.instructions}</div>
      )}

      {errors.hasOwnProperty(input_name) && (
        <div className="field__error">{errors[input_name].message}</div>
      )}
    </div>
  )
}

CheckboxGroup.defaultProps = defaultProps

export default CheckboxGroup
